module.exports = __webpack_public_path__ + "img/appLogo.d9ed2aee.svg";